import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { GoCheck } from 'react-icons/go';
import useIsDesktopSize from '../../utils/isDesktopHook';
import {
    cta,
    ctaRow,
    heading,
    checklist,
    bulletIcon,
    ctaBtnRow,
    ctaBtn,
    imgRiseOnHover,
    imgRight,
    imgRightLg,
} from './cta.module.scss';

const CtaBusiness0 = ({ primaryEventId, secondaryEventId }) => {
    const isDesktopSize = useIsDesktopSize();
    const { screenshotImg } = useStaticQuery(IMG_QUERY);

    return (
        <section className={`${cta} section-bg-gray`}>
            <div className={`section-inner align-center justify-between ${ctaRow} `}>
                <div>
                    <span className={`eyebrow eyebrow-caps eyebrow-secondary`}>
                        Payroll made easy
                    </span>
                    <h2 className={`${heading}`}>
                        An easy, time-saving <strong>payroll solution</strong> for your{' '}
                        <strong>small business</strong>.
                    </h2>
                    <div>
                        <ul className={`${checklist}`}>
                            <li>
                                <GoCheck className={`${bulletIcon}`} />
                                Unlimited employees and payroll runs
                            </li>
                            <li>
                                <GoCheck className={`${bulletIcon}`} />
                                Forms 940, 941 and W-2
                            </li>
                            <li>
                                <GoCheck className={`${bulletIcon}`} />
                                Low annual price
                            </li>
                        </ul>
                    </div>
                    <div className={`${ctaBtnRow}`}>
                        <a
                            href="https://payroll.paycheckcity.com/login/"
                            className={`${ctaBtn} btn btn-secondary`}
                            id={primaryEventId}>
                            Start 14-day free trial
                        </a>
                        <Link
                            to="/"
                            className={`${ctaBtn} btn-text-gray btn-text-lg`}
                            id={secondaryEventId}>
                            See all features
                        </Link>
                    </div>
                </div>
                <>
                    {isDesktopSize ? (
                        <Link to="/" className={`${imgRiseOnHover} ${imgRight} ${imgRightLg}`} aria-label="Learn about PaycheckCity Payroll">
                            <GatsbyImage
                                image={getImage(screenshotImg)}
                                objectFit={'contain'}
                                alt="PaycheckCity Payroll is the most affordable solution for small-business payroll."
                                role="presentation"
                            />
                        </Link>
                    ) : (
                        ``
                    )}
                </>
            </div>
        </section>
    );
};

const IMG_QUERY = graphql`
    {
        screenshotImg: file(relativePath: { eq: "payroll/run-payroll-screenshot.png" }) {
            childImageSharp {
                gatsbyImageData(width: 700, quality: 100)
            }
        }
    }
`;

CtaBusiness0.propTypes = {
    primaryEventId: PropTypes.string.isRequired,
    secondaryEventId: PropTypes.string.isRequired,
};

export default CtaBusiness0;
